import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

/** Example input:
 * date="04.06.2025 16:43:11"
 * format="DD.MM.YYYY HH:mm:ss"
 */
export const parseDate = (date: dayjs.ConfigType, format: dayjs.OptionType): dayjs.Dayjs => {
    return dayjs(date, format);
};
